import { render } from "./inputSearch.vue?vue&type=template&id=45fca630&scoped=true"
import script from "./inputSearch.vue?vue&type=script&lang=js"
export * from "./inputSearch.vue?vue&type=script&lang=js"

import "./inputSearch.vue?vue&type=style&index=0&id=45fca630&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fca630"]])

export default __exports__